import { View } from "../../Base";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import KeyValue from "./KeyValue";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { formatMinutesToHHMM } from "../../../utils/date";
import moment from "moment";
import { RouteDelimiter } from "./RouteDelimiter";

const useStyles = makeStyles({
  container: {
    margin: "20px 0",
  },
  tableHeader: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  row: {
    display: "flex",
    width: "100%",
  },
  column: {
    flex: 1,
  },
});

export const OptimiseResultsPerRoute = ({ route, impactedRoute = false }) => {
  const styles = useStyles();

  const [oldOptimisation, setOldOptimisation] = useState(null);
  const [newOptimisation, setNewOptimisation] = useState(null);

  useEffect(() => {
    setOldOptimisation(
      !route || isEmpty(route.oldRouteOptimisation)
        ? null
        : route.oldRouteOptimisation
    );
    setNewOptimisation(
      !route || isEmpty(route.routeOptimisation)
        ? null
        : route.routeOptimisation
    );
  }, [route]);

  const totalExceptions = (optimisationResults) => {
    if (!optimisationResults) return "?";

    return (
      (optimisationResults.postcodeExceptions || 0) +
      (optimisationResults.serviceExceptions || 0) +
      (optimisationResults.rangeExceptions || 0) +
      (optimisationResults.dutyExceptions || 0) +
      (optimisationResults.legalDutyExceptions || 0)
    );
  };

  return (
    <View className={styles.container}>
      {impactedRoute && (
        <View>
          <RouteDelimiter routeCode={route.routeCode} />
        </View>
      )}

      <View className={styles.row}>
        <View className={styles.column}></View>
        <View className={styles.column}>
          <Typography className={styles.tableHeader}>Previous</Typography>
        </View>
        <View className={styles.column}>
          <Typography className={styles.tableHeader}>Now</Typography>
        </View>
      </View>
      <View className={styles.row}>
        <View className={styles.column}>
          <Typography className={styles.tableHeader}>Opportunity</Typography>
        </View>
        <View className={styles.column}>
          {!oldOptimisation
            ? "??:??"
            : formatMinutesToHHMM(oldOptimisation.opportunityTime)}
        </View>
        <View className={styles.column}>
          {!newOptimisation
            ? "??:??"
            : formatMinutesToHHMM(newOptimisation.opportunityTime)}
        </View>
      </View>
      <View className={styles.row}>
        <View className={styles.column}>
          <Typography className={styles.tableHeader}>Exceptions</Typography>
        </View>
        <View className={styles.column}>
          {totalExceptions(oldOptimisation)}
          <View>
            <KeyValue
              property={"Postcode"}
              value={
                oldOptimisation ? oldOptimisation.postcodeExceptions || 0 : "?"
              }
            />
            <KeyValue
              property={"Service"}
              value={
                oldOptimisation ? oldOptimisation.serviceExceptions || 0 : "?"
              }
            />
            <KeyValue
              property={"Range"}
              value={
                oldOptimisation ? oldOptimisation.rangeExceptions || 0 : "?"
              }
            />
            <KeyValue
              property={"Duty"}
              value={
                oldOptimisation ? oldOptimisation.dutyExceptions || 0 : "?"
              }
            />
            <KeyValue
              property={"Legal Duty"}
              value={
                oldOptimisation ? oldOptimisation.legalDutyExceptions || 0 : "?"
              }
            />
          </View>
        </View>

        <View className={styles.column}>
          {totalExceptions(newOptimisation)}
          <View>
            <KeyValue
              property={"Postcode"}
              value={newOptimisation ? newOptimisation.postcodeExceptions : "?"}
            />
            <KeyValue
              property={"Service"}
              value={newOptimisation ? newOptimisation.serviceExceptions : "?"}
            />
            <KeyValue
              property={"Range"}
              value={newOptimisation ? newOptimisation.rangeExceptions : "?"}
            />
            <KeyValue
              property={"Duty"}
              value={newOptimisation ? newOptimisation.dutyExceptions : "?"}
            />
            <KeyValue
              property={"Legal Duty"}
              value={
                newOptimisation ? newOptimisation.legalDutyExceptions : "?"
              }
            />
          </View>
        </View>
      </View>
      <View className={styles.row}>
        <View className={styles.column}>
          <Typography className={styles.tableHeader}>
            Return To Depot
          </Typography>
        </View>
        <View className={styles.column}>
          {oldOptimisation
            ? moment(oldOptimisation.returnTime, "HH:mm").format("HH:mm")
            : "??:??"}
        </View>
        <View className={styles.column}>
          {newOptimisation
            ? moment(newOptimisation.returnTime, "HH:mm").format("HH:mm")
            : "??:??"}
        </View>
      </View>
    </View>
  );
};
